/**
 * 横スクロールサムネイルを grab（ドラッグ）でスクロール
 */
function tataBindLookbookThumbnailDragScroll(root) {
  if (!root) return;

  const lists = root.querySelectorAll(
    '.tata-lookbook-quick-view .thumbnail-list, .tata-lookbook-quick-view ul.thumbnail-list'
  );

  lists.forEach((list) => {
    if (list.dataset.tataDragScroll === 'true') return;
    list.dataset.tataDragScroll = 'true';

    let activePointer = null;
    let startX = 0;
    let scrollStart = 0;
    let dragged = false;

    list.addEventListener(
      'click',
      (event) => {
        if (dragged) {
          event.preventDefault();
          event.stopImmediatePropagation();
          dragged = false;
        }
      },
      true
    );

    list.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      activePointer = event.pointerId;
      startX = event.clientX;
      scrollStart = list.scrollLeft;
      dragged = false;
    });

    list.addEventListener('pointermove', (event) => {
      if (event.pointerId !== activePointer) return;
      const delta = event.clientX - startX;
      // ドラッグが始まってから is-dragging（サムネイルの pointer-events: none）とキャプチャを付ける。
      // 押した時点で付けると click の対象がリスト側になり、サムネイルのボタンが押せなくなる
      if (!dragged && Math.abs(delta) > 4) {
        dragged = true;
        list.classList.add('is-dragging');
        try {
          list.setPointerCapture(event.pointerId);
        } catch {
          /* noop */
        }
      }
      if (!dragged) return;
      event.preventDefault();
      list.scrollLeft = scrollStart - delta;
    });

    const endDrag = (event) => {
      if (event.pointerId !== activePointer) return;
      activePointer = null;
      list.classList.remove('is-dragging');
      try {
        list.releasePointerCapture(event.pointerId);
      } catch {
        /* noop */
      }
    };

    list.addEventListener('pointerup', endDrag);
    list.addEventListener('pointercancel', endDrag);
  });
}

window.tataBindLookbookThumbnailDragScroll = tataBindLookbookThumbnailDragScroll;
